var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4266 25.2762C41.5252 28.3751 43.0747 29.9245 45.0004 29.9245C46.926 29.9245 48.4755 28.3751 51.5741 25.2763L58.1501 18.7005C59.6786 17.1721 60.4432 16.4076 61.2382 15.9486C65.2372 13.6398 68.5305 15.9312 71.2999 18.7005C74.0692 21.4699 76.3605 24.7634 74.052 28.7622C73.593 29.5573 72.8287 30.3216 71.3002 31.85L64.725 38.4252C61.626 41.5242 60.0757 43.0745 60.0757 45.0001C60.0757 46.9257 61.6252 48.4752 64.7242 51.5738L71.2999 58.1498C72.8284 59.6783 73.593 60.4426 74.052 61.2376C76.3605 65.2366 74.0692 68.5302 71.2999 71.2992C68.5309 74.069 65.2369 76.3602 61.2382 74.0513C60.4432 73.5927 59.6786 72.8285 58.1501 71.2992L51.5752 64.7247C48.4774 61.6268 46.926 60.0755 45.0004 60.0755C43.0751 60.0755 41.5237 61.6265 38.4259 64.7247L31.8507 71.2992C30.3221 72.8285 29.5578 73.5927 28.7627 74.0513C24.7641 76.3602 21.47 74.069 18.701 71.2992C15.9315 68.5302 13.6404 65.2366 15.949 61.2376C16.4081 60.4426 17.1724 59.6783 18.701 58.1498L25.2766 51.5738C28.3755 48.4752 29.925 46.9257 29.925 45.0001C29.925 43.0745 28.3747 41.5242 25.2758 38.4252L18.7007 31.85C17.1723 30.3216 16.408 29.5573 15.949 28.7622C13.6403 24.7634 15.9317 21.4699 18.701 18.7005C21.4703 15.9312 24.7638 13.6398 28.7627 15.9486C29.5578 16.4076 30.3222 17.1721 31.8507 18.7005L38.4266 25.2762Z",
    stroke: "#00AACC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.a27c8dc10d9ce51804e0c472867c1710.svg";
export { ForwardRef as ReactComponent };